namespace Core {
    angular
        .module('core')
        .directive('voucherModal', (): ng.IDirective => {
            return {
                restrict: 'E',
                scope: {
                    show: '=',
                    close: '&',
                    voucherInfo: '='
                },
                templateUrl: 'partials/Home/directivetemplate?type=VoucherModal',
                link: function($scope){
                    $scope.copyVoucherToClipboard = function(voucher) {
                        const copyElement = document.createElement('textarea');
                        copyElement.style.position = 'fixed';
                        copyElement.style.opacity = '0';
                        copyElement.textContent = voucher;
                        const body = document.getElementsByTagName('body')[0];
                        body.appendChild(copyElement);
                        copyElement.select();
                        document.execCommand('copy');
                        body.removeChild(copyElement);
                    };
                }
            };
        });
}
